<template>
  <transition name="modal-fade">
    <div v-if="show" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <button class="modal-close-button" @click="closeModal">×</button>
        <h2 class="modal-title">{{ $t('contactModal.title') }}</h2>
        <p class="modal-subtitle">{{ $t('contactModal.subtitle') }}</p>

        <form @submit.prevent="submitForm" class="contact-form">
          <div class="form-group">
            <label for="name">{{ $t('contactModal.form.nameLabel') }}</label>
            <input type="text" id="name" v-model="formData.name" required />
          </div>
          <div class="form-group">
            <label for="email">{{ $t('contactModal.form.emailLabel') }}</label>
            <input type="email" id="email" v-model="formData.email" required />
          </div>
          <div class="form-group">
            <label for="subject">{{ $t('contactModal.form.subjectLabel') }}</label>
            <input type="text" id="subject" v-model="formData.subject" required />
          </div>
          <div class="form-group">
            <label for="message">{{ $t('contactModal.form.messageLabel') }}</label>
            <textarea id="message" v-model="formData.message" rows="5" required></textarea>
          </div>
          <button type="submit" class="submit-button" :disabled="isSubmitting">
            {{ isSubmitting ? $t('contactModal.form.submittingButton') : $t('contactModal.form.submitButton') }}
          </button>
        </form>

        <transition name="success-message-fade">
          <div v-if="showSuccessMessage" class="success-message">
            {{ $t('contactModal.form.submissionSuccess') }}
          </div>
        </transition>

      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ContactFormModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      isSubmitting: false,
      showSuccessMessage: false,
      successMessageTimeout: null,
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    submitForm() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.showSuccessMessage = false; // 重置成功消息

      // axios.post('http://localhost:8800/email', this.formData) // 或者使用代理路径 '/prod-api/email'
       axios.post('/prod-api/email', this.formData)
        .then(response => {
          console.log('请求成功:', response.data);
          this.showSuccessMessage = true;
          if (this.successMessageTimeout) {
            clearTimeout(this.successMessageTimeout);
          }
          this.successMessageTimeout = setTimeout(() => {
            this.showSuccessMessage = false;
            // 成功消息消失后再关闭模态框并清空表单
            this.formData.name = '';
            this.formData.email = '';
            this.formData.subject = '';
            this.formData.message = '';
            this.closeModal();
          }, 3000);
        })
        .catch(error => {
          console.error('请求失败:', error);
          let errorMessage = this.$t('contactModal.form.submissionErrorSetup');
          if (error.response) {
            errorMessage = `${this.$t('contactModal.form.submissionErrorServer')}: ${error.response.data.message || error.response.status}`;
          } else if (error.request) {
            errorMessage = this.$t('contactModal.form.submissionErrorNetwork');
          }
          alert(errorMessage); // 错误提示暂时保留 alert，你可以按需替换
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        // 模态框关闭时，重置表单和所有状态
        this.formData.name = '';
        this.formData.email = '';
        this.formData.subject = '';
        this.formData.message = '';
        this.isSubmitting = false;
        this.showSuccessMessage = false;
        if (this.successMessageTimeout) {
          clearTimeout(this.successMessageTimeout);
          this.successMessageTimeout = null;
        }
      }
    }
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    if (this.successMessageTimeout) {
      clearTimeout(this.successMessageTimeout);
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-content {
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 500px;
  position: relative;
  font-family: Arial, sans-serif;
}

.modal-close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #888;
  cursor: pointer;
  line-height: 1;
}
.modal-close-button:hover {
  color: #333;
}

.modal-title {
  font-size: 1.8rem;
  color: #003366;
  text-align: center;
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: bold;
}

.modal-subtitle {
  font-size: 1rem;
  color: #555;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.5;
}

.contact-form .form-group {
  margin-bottom: 20px;
}

.contact-form label {
  display: block;
  margin-bottom: 8px;
  font-size: 0.95rem;
  color: #444;
  font-weight: 500;
}

.contact-form input[type="text"],
.contact-form input[type="email"],
.contact-form textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 1rem;
  color: #333;
}
.contact-form input[type="text"]:focus,
.contact-form input[type="email"]:focus,
.contact-form textarea:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.contact-form textarea {
  resize: vertical;
  min-height: 100px;
}

.submit-button {
  display: block;
  width: 100%;
  padding: 12px 15px;
  background-color: #5a6773;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.submit-button:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
}

.submit-button:not(:disabled):hover {
  background-color: #4a545e;
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  padding: 10px 15px;
  border-radius: 4px;
  text-align: center;
  margin-top: 20px;
  font-size: 0.95rem;
}

.success-message-fade-enter-active, .success-message-fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.success-message-fade-enter, .success-message-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}
.modal-fade-enter-active .modal-content,
.modal-fade-leave-active .modal-content {
  transition: transform 0.3s ease;
}
.modal-fade-enter .modal-content,
.modal-fade-leave-to .modal-content {
  transform: translateY(-20px);
}
</style>